<template>
  <section class="aws">
    <div class="acctname">
      <label>
        Account Name
        <span class="required">*</span>
      </label>
      <div
        class="desc"
      >Descriptive name of the account for the customer (such as a business unit, application, or DXC offering name)</div>
      <v-text-field
        v-model="accountName"
        disabled
        solo/>
    </div>
    
    <div class="header">
      <span>Questionnaire</span>
    </div>
    <div class="content">
      <v-container fluid>
        <div v-if="type=='Internal'">
          <v-layout v-if="isTrainingAccount">
            <v-flex md6>
              <label>Is this training account going to be for individual or for one time bulk training setup?<span class="required">*</span></label>
              <v-select
                attach
                placeholder="Select an option"
                solo
                :items="trainingTypes"
                v-model="awsAccountOnboarding.fields.Internal_Individual_Training"
                @change="setIsBulkTraining"
              />
            </v-flex>
          </v-layout>
          <v-layout v-if="isBulkTraining">
            <formSingleUploads isForNewAwsAccount/>
          </v-layout>
          <v-layout
          row
          wrap
          v-if="isTrainingAccount && awsAccountOnboarding.fields.Internal_Individual_Training === 'Bulk Training'">
          <v-flex md6>
            <label>
              WBS Code
              <span class="required">*</span>
            </label>
            <v-text-field
              v-model="awsAccountValidation.wbsCode"
              maxlength="50"
              solo/>
          </v-flex>
        </v-layout>
          <v-layout
          row
          wrap
          v-if="isTrainingAccount">
          <v-flex md6>
            <label>
              Manager's Name (Organizer name for bulk training)
              <span class="required">*</span>
            </label>
            <v-text-field
              v-model="awsAccountOnboarding.fields.Manager_Name"
              maxlength="50"
              solo/>
          </v-flex>
        </v-layout>
        <v-layout
          row
          wrap
          v-if="isTrainingAccount">
          <v-flex md6>
            <label>
              Manager's Email Address (Organizer email for bulk training)
              <span class="required">*</span>
            </label>
            <v-text-field
              v-model="awsAccountOnboarding.fields.Manager_Email"
              maxlength="50"
              solo/>
          </v-flex>
        </v-layout>
        </div>

        <v-layout
          row
          wrap>
          <v-flex
            xs12
            sm12
            md10
            xl10>
            <label v-if="!isTrainingAccount">Which DXC region will this account or customer be a part of?</label>
            <label v-if="isTrainingAccount">Which DXC region will this account be a part of?</label>
          </v-flex>
          <v-flex
            xs12
            sm12
            md2
            xl2>
            <v-select
              attach
              placeholder="Select DXC Region"
              solo
              :items="dxcRegions"
              v-model="awsAccountOnboarding.fields.Specific_Region"
            />
          </v-flex>
        </v-layout>
        <!--  For Internal Client Questionnaire -->
        <v-layout
          v-if="!isTrainingAccount"
          row
          wrap>
          <v-flex
            xs12
            sm8
            md8
            xl8>
            <label>
              Will this workload include a DXC-owned software-based or SaaS solution where the end customer does not directly access the AWS account?
              <span class="required">*</span>
            </label>
          </v-flex>

          <v-flex
            xs12
            sm4
            md4
            xl4>
            <v-layout
              column
              align-end>
              <v-btn-toggle v-model="awsAccountOnboarding.fields.SaaS">
                <v-btn
                  class="button-style-1"
                  value="Yes">Yes</v-btn>
                <v-btn
                  class="button-style-1"
                  value="No">No</v-btn>
              </v-btn-toggle>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout
          v-if=" awsAccountOnboarding.fields.SaaS === 'Yes'"
          row
          wrap>
          <v-flex
            xs12
            sm12
            md12
            xl12>SaaS Product Solution</v-flex>
          <v-flex
            xs12
            sm12
            md12
            xl12>
            <v-text-field
              v-model="awsAccountOnboarding.fields.SaaS_Solution"
              solo/>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-if="type==='Internal'">
          <v-flex xs12 sm8 md8 xl8>
            <label>Do you have AWS Credits or Promo Code?</label>
          </v-flex>
          <v-flex
            xs12
            sm4
            md4
            xl4>
            <v-layout
              column
              align-end >
              <v-btn-toggle v-model="awsAccountOnboarding.isPromoCode">
                <v-btn
                  class="button-style-1"
                  value="Yes">Yes</v-btn>
                <v-btn
                  class="button-style-1"
                  value="No">No</v-btn>
              </v-btn-toggle>
            </v-layout>
          </v-flex>
          <v-flex
            v-if="awsAccountOnboarding.isPromoCode === 'Yes'"
            xs12
            sm12
            md12
            xl12>
            <label>AWS Credits</label>
            <v-text-field
              v-model="awsAccountValidation.awsCredits"
              solo/>
          </v-flex>
        </v-layout>

        <v-layout
          row
          wrap>
          <v-flex
            xs12
            sm12
            md12
            xl12>
            <label>
              Enter Short-Name Description
              <span class="required">*</span>
            </label>
            <v-text-field
              v-model="awsAccountOnboarding.fields.Client_Shortname"
              placeholder="Enter (in one word) name of the application or business unit or the purpose for which the AWS account is being used"
              maxlength="15"
              solo/>
          </v-flex>
        </v-layout>

        <v-layout
          row
          wrap>
          <v-flex
            xs12
            sm12
            md6
            xl6>
            <v-layout
              v-if="!isTrainingAccount"
              row
              wrap>
              <v-flex
                xs12
                sm6
                md6
                xl5>
                <label>
                  Is this account regionally restricted?
                  <span class="required">*</span>
                </label>
              </v-flex>
              <v-flex
                xs12
                sm6
                md5
                xl6>
                <v-layout
                  column
                  align-end>
                  <v-btn-toggle
                    v-model="awsAccountOnboarding.Region"
                    style="margin-bottom:20px">
                    <v-btn
                      class="button-style-1"
                      value="true">Yes</v-btn>
                    <v-btn
                      class="button-style-1"
                      value="false">No</v-btn>
                  </v-btn-toggle>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex
            xs12
            sm12
            md6
            xl6>
            <div v-if="awsAccountOnboarding.Region === 'true'">
              <v-layout
                row
                wrap>
                <v-flex
                  xs12
                  sm12
                  md6
                  xl6>
                    <label>
                      Region
                      <span class="required">*</span>
                    </label>
                </v-flex>
                <v-flex
                  xs12
                  sm12
                  md6
                  xl6>
                  <v-select
                    attach
                    placeholder="Select a Region"
                    solo
                    :items="restrictedRegions"
                    item-text="Name"
                    item-value="Id"
                    v-model="awsAccountOnboarding.fields.Restricted_Region_Id"
                  />

              
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
        </v-layout>

        <v-layout
          v-if="!isTrainingAccount"
          row
          wrap>
          <v-flex
            xs12
            sm12
            md6
            xl6>
            <v-layout
              row
              wrap>
              <v-flex
                xs12
                sm6
                md6
                xl6>
                <label>
                  Is this account country restricted ?
                  <span class="required">*</span>
                </label>
              </v-flex>
              <v-flex
                xs12
                sm6
                md5
                xl5>
                <v-layout
                  column
                  align-end>
                  <v-btn-toggle
                    v-model="awsAccountOnboarding.isLocationSpecific"
                    style="margin-bottom:20px"
                  >
                    <v-btn
                      class="button-style-1"
                      value="true">Yes</v-btn>
                    <v-btn
                      class="button-style-1"
                      value="false">No</v-btn>
                  </v-btn-toggle>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex
            xs12
            sm12
            md6
            xl6>
            <div v-if="awsAccountOnboarding.isLocationSpecific === 'true'">
              <v-layout
                row
                wrap>
                <v-flex
                  xs12
                  sm12
                  md3
                  xl3>
                  <v-layout
                    column
                    align-space-around
                    row>
                    <label>
                      Enter Location
                      <span class="required">*</span>
                    </label>
                  </v-layout>
                </v-flex>
                <v-flex
                  xs12
                  sm12
                  md9
                  xl9>
                  <!-- <v-select
                    :items="countries"
                    v-model="awsAccountOnboarding.fields.Specific_Location"
                    name="country"
                    item-text="country"
                    placeholder="Select a Country"
                    required
                    solo
                    attach
                  /> -->

                  <v-autocomplete
                    :items="countries"
                    v-model="awsAccountOnboarding.fields.Specific_Location"
                    name="country"
                    item-text="country"
                    label="Select a Country"
                    data-vv-validate-on="blur"
                    cache-items
                    flat
                    hide-no-data
                    hide-details
                    attach
                    light
                    no-data-text="No results found"
                    solo
                   />

                </v-flex>
              </v-layout>
            </div>
          </v-flex>
        </v-layout>

        <v-layout
          v-if="!isTrainingAccount"
          row
          wrap
          style="margin-bottom:25px">
          <v-flex
            xs12
            sm8
            md8
            xl8>
            <label>
              Will this account be subject to any regulations or laws that may restrict the nationality of DXC employees who may view information related to the account – OR – any restrictions based on specific contractual or sensitive data that may require special handling?
              <span class="required">*</span>
            </label>
            <div style="font-size:14px; font-style:italic">
              (
              <span style="font-weight: 5600">note:</span> answering Yes to this question may result in additional costs if a separate Master Payer account is required)
            </div>
          </v-flex>
          <v-flex
            xs12
            sm4
            md4
            xl4>
            <v-layout
              column
              align-end>
              <v-btn-toggle v-model="awsAccountOnboarding.requireRegulations">
                <v-btn
                  class="button-style-1"
                  value="1">Yes</v-btn>
                <v-btn
                  class="button-style-1"
                  value="0">No</v-btn>
              </v-btn-toggle>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout
          row
          wrap
          v-if="!isTrainingAccount">
          <v-flex
            xs12
            sm12
            md3
            xl2>
            <label>
              Describe the business use for this account:
              <span class="required">*</span>
            </label>
          </v-flex>
          <v-flex
            xs12
            sm12
            md9
            xl10>
            <v-textarea
              v-model="awsAccountOnboarding.fields.Acct_Description"
              placeholder="Provide the project description for this AWS account"
              solo/>
          </v-flex>
        </v-layout>

        <v-layout
          row
          wrap
          v-if="isTrainingAccount">
          <v-flex
            xs12
            sm12
            md3
            xl2>
            <label>
              What AWS service will be used for training and certification?
              <span class="required">*</span>
            </label>
          </v-flex>
          <v-flex
            xs12
            sm12
            md9
            xl10>
            <v-textarea
              v-model="awsAccountOnboarding.fields.AWS_Service"
              solo/>
          </v-flex>
        </v-layout>

        <v-layout
          row
          wrap
          v-if="!isTrainingAccount">
          <v-flex
            xs12
            sm6
            md6
            xl6
            >
            <label>
              What is the purpose of this account?
              <span class="required">*</span>
            </label>
          </v-flex>
          <v-flex
            xs12
            sm6
            md6
            xl6>
            <v-layout
              column
              align-end>
              <v-select
                :items="purposes"
                v-model="awsAccountOnboarding.AWS_Purpose.all"
                class="v-select--width"
                full-width
                chips
                label="Choose your purpose"
                solo
                attach
                clearable
                @change="selectedPurpose"
              />
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout
          row
          wrap>
          <v-flex
            xs12
            sm6
            md6
            xl6>
            <label>If this AWS account will be for a GovCloud customer, please enter the Resource Account number:</label>
          </v-flex>
          <v-flex
            xs12
            sm6
            md6
            xl6>
            <v-layout
              column
              align-end>
              <v-text-field
                v-model="awsAccountOnboarding.fields.GovCloud_Resource_Account"
                placeholder="GovCloud Account number"
                maxlength="30"
                class="text50"
                solo/>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout
          row
          wrap
          v-if="!isTrainingAccount">
          <v-flex
            xs12
            sm6
            md6
            xl6>
            <label>
              What type of Managed Services Support will this account have?
              <span class="required">*</span>
            </label>
          </v-flex>
          <v-flex
            xs12
            sm6
            md6
            xl6>
            <v-layout
              column
              align-end>
              <v-radio-group
                v-model="awsAccountOnboarding.fields.Managed_Svc"
                row>
                <v-radio
                  label="DXC Gold"
                  value="DXC Gold"/>
                <v-radio
                  label="DXC Silver"
                  value="DXC Silver"/>
              </v-radio-group>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout
          row
          wrap>
          <v-flex
            xs12
            sm12
            md4
            xl4>
            <label>
              What AWS Support is required?
              <span class="required">*</span>
            </label>
          </v-flex>
          <v-flex
            xs12
            sm12
            md8
            xl8>
            <v-layout
              column
              align-end>
              <v-radio-group
                v-model="awsAccountOnboarding.fields.AWS_Support_Type"
                row>
                <v-radio
                  label="Enterprise Support"
                  value="Enterprise Support"/>
                <v-radio
                  v-if="!isTrainingAccount && type!='Internal'"
                  label="Business Support+"
                  value="Business Support+"/>
                <v-radio
                  v-if="!isTrainingAccount && type!='Internal'"
                  label="Basic Support"
                  value="Basic Support"/>
              </v-radio-group>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout
          row
          wrap>
          <v-layout
            column
            wrap
            align-center
            justify-center>
            <v-flex
              xs12
              sm12
              md12>
              <v-btn
                class="opp-btn"
                value="true"
                @click="goBack">Go Back to Previous Page</v-btn>
              <v-btn
                :disabled="!valid"
                class="opp-btn"
                color="warning"
                @click="saveQuestionnaire"
              >Save and Continue to Contact Information</v-btn>
            </v-flex>
          </v-layout>
        </v-layout>

        <!-- POC POP-UP QUESTIONS -->
        <v-layout
          row
          justify-center>
          <v-dialog
            v-model="pocDialog"
            persistent
            max-width="800">
            <template v-slot:activator="{ on }"/>
            <v-card>
              <v-card-title>POC Questions</v-card-title>
              <v-card-text>
                <v-container>
                  <v-layout
                    row
                    wrap>
                    <v-flex
                      xs12
                      sm12
                      md12
                      xl12>
                      <p
                        style=" font-weight:500"
                      >Proof of Concept and Prototype accounts have a limited lifespan and will be automatically suspended to prevent them becoming dormant accounts. Please answer the following questions to determine the expected duration of the account. You will be notified at least 2 weeks prior to suspension and given the option to extend if required.</p>
                    </v-flex>
                  </v-layout>

                  <v-layout
                    row
                    wrap>
                    <v-flex
                      xs12
                      sm12
                      md12
                      xl12>
                      <label>Do you have AWS credits for this account?</label>
                    </v-flex>
                    <v-flex
                      xs12
                      sm12
                      md12
                      xl12>
                      <v-text-field
                        v-model="awsAccountOnboarding.AWS_Purpose.poc.q1"
                        solo/>
                    </v-flex>
                  </v-layout>

                  <v-layout
                    row
                    wrap>
                    <v-flex
                      xs12
                      sm12
                      md12
                      xl12>
                      <label>What is the Redemption Code?</label>
                    </v-flex>
                    <v-flex
                      xs12
                      sm12
                      md6
                      xl12>
                      <v-text-field
                        v-model="awsAccountOnboarding.AWS_Purpose.poc.q2"
                        solo/>
                    </v-flex>
                  </v-layout>

                  <v-layout
                    row
                    wrap>
                    <v-flex
                      xs12
                      sm12
                      md12
                      xl12>
                      <label>What is the start date for this POC / Prototype?</label>
                    </v-flex>
                    <v-flex
                      xs12
                      sm12
                      md12
                      xl12>
                      <v-menu
                        v-model="menu1"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="awsAccountOnboarding.AWS_Purpose.poc.q3"
                            append-icon="event"
                            readonly
                            solo
                            v-on="on"
                          />
                        </template>
                        <v-date-picker
                          v-model="awsAccountOnboarding.AWS_Purpose.poc.q3"
                          @input="menu1 = false"
                        />
                      </v-menu>
                    </v-flex>
                  </v-layout>

                  <v-layout
                    row
                    wrap>
                    <v-flex
                      xs12
                      sm12
                      md12
                      xl12>
                      <label>What is the expected end date for this POC / Prototype?</label>
                    </v-flex>
                    <v-flex
                      xs12
                      sm12
                      md12
                      xl12>
                      <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="awsAccountOnboarding.AWS_Purpose.poc.q4"
                            append-icon="event"
                            readonly
                            solo
                            v-on="on"
                          />
                        </template>
                        <v-date-picker
                          v-model="awsAccountOnboarding.AWS_Purpose.poc.q4 "
                          @input="menu2 = false"
                        />
                      </v-menu>
                    </v-flex>
                  </v-layout>

                  <v-layout
                    row
                    wrap>
                    <v-flex
                      xs12
                      sm12
                      md12
                      xl12>
                      <label>Is this POC or Prototype Client-funded?</label>
                    </v-flex>
                    <v-flex
                      xs12
                      sm12
                      md12
                      xl12>
                      <v-layout
                        column
                        align-end>
                        <v-btn-toggle v-model="awsAccountOnboarding.AWS_Purpose.poc.q5">
                          <v-btn
                            value="1"
                            style="padding: 15px 25px;">Yes</v-btn>
                          <v-btn
                            value="0"
                            style="padding: 15px 25px;">No</v-btn>
                        </v-btn-toggle>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer/>
                <v-btn
                  color="orange darken-1"
                  text
                  @click="pocDialog = false">Close</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>

        <!-- Law and Regulation Pop-up -->
        <v-layout
          row
          justify-center>
          <v-dialog
            v-if="isRegulation"
            v-model="regulationsDialog"
            persistent
            scrollable
            max-width="800"
          >
            <template v-slot:activator="{ on }"/>
            <v-card>
              <v-card-title>Laws and Regulations</v-card-title>
              <v-card-text>
                <v-container>
                  <v-layout
                    row
                    wrap>
                    <v-flex
                      xs12
                      sm12
                      md12
                      xl12>
                      <label>
                        What laws or regulations require restriction for this account? Choose all applicable items. &nbsp;
                        <i>(Please check at least one of the options)</i>
                      </label>
                    </v-flex>
                    <v-flex
                      xs12
                      sm12
                      md12
                      xl12>
                      <v-checkbox
                        v-model="awsAccountOnboarding.Customer_Regulations"
                        label="GDPR"
                        value="GDPR"
                      />
                      <v-checkbox
                        v-model="awsAccountOnboarding.Customer_Regulations"
                        label="ITAR"
                        value="ITAR"
                      />
                      <v-checkbox
                        v-model="awsAccountOnboarding.Customer_Regulations"
                        label="FISC"
                        value="FISC"
                      />
                      <v-checkbox
                        v-model="awsAccountOnboarding.Customer_Regulations"
                        label="HIPPA"
                        value="HIPPA"
                      />
                      <v-checkbox
                        v-model="awsAccountOnboarding.Customer_Regulations"
                        label="US Healthcare"
                        value="US Healthcare"
                      ></v-checkbox>
                       <v-checkbox
                        v-model="awsAccountOnboarding.Customer_Regulations"
                        label="EU citizen restricted"
                        value="EU citizen restricted"
                      ></v-checkbox>
                      <v-checkbox
                        v-model="awsAccountOnboarding.Customer_Regulations"
                        label="US citizen restricted"
                        value="US citizen restricted"
                      />
                      <v-checkbox
                        v-model="awsAccountOnboarding.Customer_Regulations"
                        label="UK citizen restricted"
                        value="UK citizen restricted"
                      />
                      <v-checkbox
                        v-model="awsAccountOnboarding.Customer_Regulations"
                        label="Australian citizen restricted"
                        value="Australian citizen restricted"
                      />
                      <v-checkbox
                        v-model="awsAccountOnboarding.Customer_Regulations"
                        :value="contractRestrictionValue"
                        hide-details
                        class="shrink mr-2 mt-0"
                        label="Contract Restriction"
                      />
                      <v-text-field
                        ref="contractResInput"
                        v-model="contractRestrictionText"
                        :disabled="disableContractRestrictionText"
                        label="(please describe)"
                        @blur="addToCustomerRegulations(contractRestrictionValue)"
                      />

                      <v-checkbox
                        v-model="awsAccountOnboarding.Customer_Regulations"
                        :value="otherRestrictionValue"
                        hide-details
                        class="shrink mr-2 mt-0"
                        label="Other Restriction"
                      />
                      <v-text-field
                        ref="otherResInput"
                        v-model="otherRestrictionText"
                        :disabled="disableOtherRestrictionText"
                        label="(please describe)"
                        @blur="addToCustomerRegulations(otherRestrictionValue)"
                      />
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer/>
                <v-btn
                  color="darken-1"
                  text
                  @click="regulationsDialog = false">Close</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-container>
    </div>
  </section>
</template>

<script>
import { METHODS } from 'http'
import { mapMutations, mapState, mapActions, mapGetters } from 'vuex'
import { getCountries, generateRegistrationID } from '@/utils/helper'

export default {
  props: ['opportunityName', 'type'],
  data () {
    return {
      location: null,
      countryCode: null,
      countries: getCountries(),
      testPurpose: null,
      pocDialog: false,
      acctType: null,
      requireRegulations: false,
      regulationsDialog: false,
      isRegulations: false,
      accountSubjectToRegulation: false,
      date1: new Date().toISOString().substr(0, 10),
      date2: new Date().toISOString().substr(0, 10),
      menu: false,
      modal: false,
      menu1: false,
      menu2: false,
      // customerRegulations: [],
      contractRestrictionValue: 'Contract Restriction',
      otherRestrictionValue: 'Other Restriction',
      contractRestrictionText: '',
      otherRestrictionText: '',
      internalAccountTypes: ['Testing', 'Training', 'Lab Environment', 'POC'],
      trainingTypes: ['Individual', 'Bulk Training'],
      isTrainingAccount: false,
      isBulkTraining: false
    }
  },
  computed: {
    ...mapState("user/requestAws", [
      "newAwsAccount",
      "newAwsAcctExistingClient",
      "newAwsAcctInternalClient",
      "awsAccountValidation",
      "awsAccountOnboarding",
      "dxcRegions",
      "regions",
      "restrictedRegions",
      "onboardingRecords",
      "purposes",
      "countries",
      "showRequestAwsQuestionnaire",
      "showRequestAwsContacts",
      "s3FileUpload"
    ]),
    accountName () {
      let customerName = ''
      // let customerName = this.newAwsAccount.opportunityName
      let purposes = this.awsAccountOnboarding.AWS_Purpose.all;
      let primaryPurpose = purposes;
      let purpose = this.awsAccountOnboarding.AWS_Purpose.primary;
      let awsPurpose;
      if (this.type === "New") {
        // customerName = this.newAwsAccount.opportunityName;
        customerName = this.awsAccountOnboarding.fields.Customer_Alias
        console.log('** New Client Customer Name: ', customerName)
        this.awsAccountOnboarding.fields.Cust_Shortname = customerName
      } else if (this.type === "Existing") {
        customerName = this.newAwsAcctExistingClient.Customer_Alias;
        this.awsAccountOnboarding.fields.Cust_Shortname = customerName
      } else if (this.type === "Internal") {
        customerName = this.newAwsAcctInternalClient.Customer_Alias;
        this.awsAccountOnboarding.fields.Cust_Shortname = customerName
      }

      console.log('Purpose: ', primaryPurpose)

      if (primaryPurpose == 'Production(Prod)') {
        awsPurpose = '-prod'
      } else if (primaryPurpose === 'Staging(Stage)') {
        awsPurpose = '-stage'
      } else if (primaryPurpose === 'Quality Assurance (QA)') {
        awsPurpose = '-qa'
      } else if (primaryPurpose === 'Development (Dev)') {
        awsPurpose = '-dev'
      } else if (primaryPurpose === 'Test (Test)') {
        awsPurpose = '-test'
      } else if (primaryPurpose === 'Proof of Concept or Prototype(POC)') {
        awsPurpose = '-poc'
      } else if (primaryPurpose === 'Demonstration (Demo)') {
        awsPurpose = '-demo'
      } else if (
        primaryPurpose === 'Sandbox (SB)' ||
        primaryPurpose === 'Training'
      ) {
        awsPurpose = '-sandbox'
      } else if(this.isTrainingAccount) {
        awsPurpose = '-training'
      }else {
        awsPurpose = ''
      }

      // IF awsType is 'new' then run condition on checking the oppreg status
      // 'new' condition: if Oppreg Status is equal to 'Approved - Tier 3 12%' accountType must be SPP
      // 'new' condition: if Oppreg Status is equal to 'Approved - Tier 3 23%' accountType must be PPA
      // 'new' condition: if Oppreg Status is equal to 'Approved - Tier 2 - Custom EDP' account type must be EDP
      // IF awsType is 'existing'  then run anothe condition if customer name
      // is equal to 'Vale' then the account type is EDP else SPP
      // IF awsType is 'internal' then account type is PPA

      if (this.type === "New") {
        let workloadType = this.newAwsAccount.workloadType;
        if (workloadType) {
          this.acctType = workloadType
        } else {
          let status = this.newAwsAccount.oppregStatus;
          if (status) {
            if (
              status === 'Approved - Tier 3 12%' ||
              status === 'Approved – Tier 3 12%'
            ) {
              this.acctType = 'spp'
            }
            if (status === 'Approved - Tier 1 23% - PPA' || status === 'Approved - Tier 1 23% - PPA SaaS') {
              this.acctType = 'ppa'
            }
            if (status === 'Approved - Tier 2 - Custom EDP') {
              this.acctType = 'edp'
            }
            if (status === 'Submitted by User' || status === 'Submitted to AWS'){
              this.acctType = 'tbd'
            }
          }
        }

        
      } else if (this.type === "Existing") {
          let workloadtype = this.newAwsAcctExistingClient.Workload_Type

          if (workloadtype) {
            this.acctType = workloadtype
          } else {

            let workloadStatus = this.newAwsAcctExistingClient.Workload_Status
            let oppregStatus = ''

            let selCustAgreement =  this.newAwsAcctExistingClient.selectedCustomerAgreement
            let customer = this.newAwsAcctExistingClient.Customer_Name;

            if(selCustAgreement !== null && selCustAgreement !== undefined && selCustAgreement !== "" ){
              this.acctType = selCustAgreement
            } else {
              if(customer === "Vale"){
                this.acctType = "edp";
              } 
              if(workloadtype !== '' && customer !== 'Vale') {
                if (workloadStatus === 'Approved - Tier 3 12%' || workloadStatus=== 'Approved – Tier 3 12%') {
                  oppregStatus = 'SPP'
                }
                if (workloadStatus === 'Approved - Tier 1 23% - PPA' || workloadStatus === 'Approved - Tier 1 23% - PPA SaaS') {
                  oppregStatus = 'PPA'
                }

                if(workloadStatus === 'Approved - Tier 3 12%' 
                || workloadStatus=== 'Approved – Tier 3 12%' 
                || workloadStatus === 'Approved - Tier 1 23% - PPA' 
                || workloadStatus === 'Approved - Tier 1 23% - PPA SaaS') {
                  if(workloadtype !== oppregStatus){
                    this.acctType = oppregStatus
                    this.newAwsAcctExistingClient.accountRecord.onboarding.WS_Selected = oppregStatus
                  } else {
                    this.acctType = workloadtype 
                  }
                } else {
                  this.acctType = workloadtype
                }
              }
              if(workloadtype === '' && customer !== 'Vale') {
                this.acctType = 'tbd'
              }
            }
          }

      } else if (this.type === "Internal") {
        this.acctType = "ppa";
      }

      // IF Restricted Region === true AND specific_location  === true THEN put ISO Code of the country
      // ELSE IF Restricted Region === true AND specific_location  === false THEN put region

      let isRegion = this.awsAccountOnboarding.Region
      let isLocationSpecific = this.awsAccountOnboarding.isLocationSpecific

      let specificRegion = this.awsAccountOnboarding.fields.Restricted_Region_Id;
      let specificLocation = this.awsAccountOnboarding.fields.Specific_Location;

      let isoCode = this.countries.filter(res => {
        if (res.country == this.awsAccountOnboarding.fields.Specific_Location) {
          return res.code
        }
      })
      if (isoCode.length > 0) {
        this.countryCode = isoCode[0].code
      }

      if (isRegion && isLocationSpecific) {
        if (isLocationSpecific === 'false' && isRegion === 'true') {
          if (specificRegion !== null) {
           let resRegionName =  this.restrictedRegions.filter( reg => reg.Id == specificRegion)
           console.log('resRegionName ' + resRegionName[0].Name)
            this.location = "-" + resRegionName[0].Name
          }
        } else if (isLocationSpecific === 'false' && isRegion == 'false') {
          this.location = ''
        } else {
          if (this.countryCode !== null) {
            this.location = '-' + this.countryCode
          }
        }
      } else if (!isRegion && isLocationSpecific) {
        if (isLocationSpecific !== 'false') {
          this.location = '-' + this.countryCode
        }
      } else if (isRegion && !isLocationSpecific) {
        if (isRegion === 'true') {
          if (specificRegion !== null) {
           let resRegionName =  this.restrictedRegions.filter( reg =>
            reg.Id == specificRegion 
            )
           console.log('resRegionName ' + resRegionName[0].Name)
            this.location = "-" + resRegionName[0].Name
          }
        }
      } else {
        console.log('empty')
      }

      console.log('AccountType:: ' + this.acctType)
      console.log('Final Customer Name: ' + customerName.replace(/\s+/g, ''))

      let shortname =
        this.awsAccountOnboarding.fields.Client_Shortname !== null
          ? "-" +
            this.awsAccountOnboarding.fields.Client_Shortname.replace(
              /[^A-Z0-9]/gi,
              ''
            )
          : ''
      let loc = this.location !== null ? this.location : ''
      let awsAcctName ='aws-' + this.acctType + '-' + customerName.replace(/\s+/g, '') + shortname + awsPurpose + loc
      return (this.awsAccountOnboarding.fields.Acct_name = awsAcctName.toUpperCase())
    },
    valid() {
      if (this.type !== "Internal") {
        let validRegion = (this.awsAccountOnboarding.Region == "true" && this.awsAccountOnboarding.fields.Restricted_Region_Id) ||this.awsAccountOnboarding.Region == "false";
        let validLocation =(this.awsAccountOnboarding.isLocationSpecific == "true" && this.awsAccountOnboarding.fields.Specific_Location) ||this.awsAccountOnboarding.isLocationSpecific == "false";
        let validRegulations =(this.awsAccountOnboarding.requireRegulations == 1 &&this.awsAccountOnboarding.Customer_Regulations.length) ||this.awsAccountOnboarding.requireRegulations == 0;

        return (
          this.awsAccountOnboarding.AWS_Purpose.all.length &&
          this.awsAccountOnboarding.fields.Client_Shortname &&
          validRegion &&
          validLocation &&
          this.awsAccountOnboarding.fields.Acct_Description &&
          this.awsAccountOnboarding.fields.Acct_name &&
          this.awsAccountOnboarding.fields.Managed_Svc &&
          this.awsAccountOnboarding.fields.AWS_Support_Type &&
          this.awsAccountOnboarding.fields.SaaS &&
          validRegulations
        )
      } else {
        let validRegion =(this.awsAccountOnboarding.Region == "true" && this.awsAccountOnboarding.fields.Restricted_Region_Id) ||this.awsAccountOnboarding.Region == "false";
        let validLocation =(this.awsAccountOnboarding.isLocationSpecific == "false" && this.awsAccountOnboarding.fields.Specific_Location) ||this.awsAccountOnboarding.isLocationSpecific == "false";
        let validRegulations =(this.awsAccountOnboarding.requireRegulations == 1 &&this.awsAccountOnboarding.Customer_Regulations.length) ||this.awsAccountOnboarding.requireRegulations == 0;
        let validBulkTraining =(this.awsAccountOnboarding.fields.Internal_Individual_Training === 'Bulk Training' && this.s3FileUpload.item)
        if (this.isTrainingAccount) {
          if(this.awsAccountOnboarding.fields.Internal_Individual_Training === 'Bulk Training') {
            return (
              this.awsAccountOnboarding.fields.Client_Shortname &&
              this.awsAccountOnboarding.fields.Specific_Region &&
              this.awsAccountOnboarding.fields.Acct_name &&
              this.awsAccountOnboarding.fields.AWS_Support_Type &&
              this.awsAccountOnboarding.fields.Manager_Name &&
              this.awsAccountOnboarding.fields.Manager_Email &&
              this.awsAccountOnboarding.fields.Internal_Individual_Training &&
              this.awsAccountOnboarding.fields.AWS_Service &&
              this.awsAccountValidation.wbsCode &&
              validBulkTraining
            )
          } else {
            return (
              this.awsAccountOnboarding.fields.Client_Shortname &&
              this.awsAccountOnboarding.fields.Specific_Region &&
              this.awsAccountOnboarding.fields.Acct_name &&
              this.awsAccountOnboarding.fields.AWS_Support_Type &&
              this.awsAccountOnboarding.fields.Manager_Name &&
              this.awsAccountOnboarding.fields.Manager_Email &&
              this.awsAccountOnboarding.fields.Internal_Individual_Training &&
              this.awsAccountOnboarding.fields.AWS_Service
            )
          }

        } else {
          return (
            this.awsAccountOnboarding.AWS_Purpose.all.length &&
            this.awsAccountOnboarding.fields.Client_Shortname &&
            validRegion &&
            // && validLocation
            this.awsAccountOnboarding.fields.SaaS &&
            this.awsAccountOnboarding.fields.Acct_Description &&
            this.awsAccountOnboarding.fields.Acct_name &&
            this.awsAccountOnboarding.fields.Managed_Svc &&
            this.awsAccountOnboarding.fields.AWS_Support_Type &&
            validRegulations
          )
        }
      }
    },
    disableContractRestrictionText () {
      let contractRestrictionIndex = this.awsAccountOnboarding.Customer_Regulations.findIndex(
        regulation =>
          regulation === 'Contract Restriction' ||
          regulation === this.contractRestrictionText
      )
      return contractRestrictionIndex === -1
    },
    disableOtherRestrictionText () {
      let otherRestrictionIndex = this.awsAccountOnboarding.Customer_Regulations.findIndex(
        regulation =>
          regulation === 'Other Restriction' ||
          regulation === this.otherRestrictionText
      )
      return otherRestrictionIndex === -1
    },
    isRegulation () {
      if (this.awsAccountOnboarding.requireRegulations == 1) {
        this.regulationsDialog = true
        return true
      } else {
        this.regulationsDialog = false
        return false
      }
    },
  },
  mounted() {
    this.setTrainingAccount();
    this.$store.dispatch('user/requestAws/getRestrictedRegions')
    this.$store.dispatch('user/requestAws/getAllOnboardingRecords')
  },
  methods: {
    ...mapActions({
      submitQuestionnaire: 'user/requestAws/saveQuestionnaire'
    }),
    selectedPurpose () {
      var purposes = this.awsAccountOnboarding.AWS_Purpose.all
      var isPOCSelected =
        purposes.indexOf('Proof of Concept or Prototype(POC)') > -1
      if (isPOCSelected) {
        this.pocDialog = true
      }
    },

    checkOnboardingRecord(acctname){
      console.log('------------------ MON --------------------')
      console.log(acctname)
      console.log('-------------------------------------------')
      let isOnboardingRecord = this.onboardingRecords.filter( reg =>
            reg.Acct_name === acctname
      )     
      return isOnboardingRecord.length 

    },
    saveQuestionnaire () {
    if (this.awsAccountOnboarding.fields.Manager_Email && this.awsAccountOnboarding.fields.Manager_Name) {
      this.$store.commit('user/requestAws/addAccountOwner', {payload: this.awsAccountOnboarding, type: 'manager'});
      this.$store.commit('user/requestAws/addFinanceOwner', this.awsAccountOnboarding);
    }
    console.log('ACCOUNT NAME: '+ this.accountName)
    let i = 0
    let stringNum = 0
    let shortnameLength
    let updatedShortName 
    while(this.checkOnboardingRecord(this.awsAccountOnboarding.fields.Acct_name) > 0){
        i+=1
      stringNum = (this.awsAccountOnboarding.fields.Client_Shortname).length
      let concatNum = 1+i.toString().length
      shortnameLength= stringNum
      let sname = this.awsAccountOnboarding.fields.Client_Shortname

      console.log('shortname length: '+ shortnameLength)
      if(shortnameLength >= 15){
        
        console.log('------- dataa -------')
        console.log(sname)
        console.log(concatNum)
          updatedShortName = sname.slice(0,-concatNum)
          console.log('-----updatedShortname------')
          console.log(updatedShortName+'0'+i)
          console.log('---------------------------')
           this.$store.commit('user/requestAws/setClientShortname', updatedShortName+'0'+i)
          this.awsAccountOnboarding.fields.Client_Shortname = updatedShortName+'0'+i
      
          this.accountName

      } else{
        let noToTrim= (shortnameLength+concatNum)
        let noToTrim1= 15-shortnameLength
        updatedShortName = sname
        console.log('------- noToTrim ------')
        console.log(concatNum)
        console.log(noToTrim)
        console.log(noToTrim1)
        console.log(updatedShortName)
        console.log(updatedShortName+'0'+i)
        console.log('-----------------------')
        if (noToTrim > 15){
          console.log('a')
           updatedShortName = sname.slice(0,-noToTrim1)
        }else{
          console.log('aa')
          updatedShortName = sname
        }
        
        this.$store.commit('user/requestAws/setClientShortname', updatedShortName+'0'+i)
        this.awsAccountOnboarding.fields.Client_Shortname = updatedShortName+'0'+i
      
        this.accountName

      }

      
      //   this.$store.commit('user/requestAws/setClientShortname', this.awsAccountOnboarding.fields.Client_Shortname+'0'+i)
      //     this.awsAccountOnboarding.fields.Client_Shortname = this.awsAccountOnboarding.fields.Client_Shortname+'0'+i
      
      //     this.accountName

      // console.log('Shortname String Length: ', this.awsAccountOnboarding.fields.Client_Shortname)


        // let lastString = /[^0]*$/.exec(this.awsAccountOnboarding.fields.Acct_name)[0]
        // if(isNaN(lastString)){ 
        //   this.awsAccountOnboarding.fields.Acct_name = this.awsAccountOnboarding.fields.Acct_name+'0'+i
        //   } else { 
        //     let index 
        //     if(i > 10){
        //       this.awsAccountOnboarding.fields.Acct_name = this.awsAccountOnboarding.fields.Acct_name.slice(0, -2);
        //       console.log(this.awsAccountOnboarding.fields.Acct_name)
        //       console.log(i)
        //       this.awsAccountOnboarding.fields.Acct_name = this.awsAccountOnboarding.fields.Acct_name+i
        //     } else{
        //       index = this.awsAccountOnboarding.fields.Acct_name.lastIndexOf("0");
        //       this.awsAccountOnboarding.fields.Acct_name = this.awsAccountOnboarding.fields.Acct_name.substring(0, index);
        //       this.awsAccountOnboarding.fields.Acct_name = this.awsAccountOnboarding.fields.Acct_name+'0'+i
        //     }
        //   }
    }

  
      
      console.log('--------------- FINAL ACCOUNT NAME -----------------')
      console.log(this.awsAccountOnboarding.fields.Acct_name)
      console.log('----------------------------------------------------')
      
     
      this.awsAccountOnboarding.fields.Account_Purpose = this.awsAccountOnboarding.AWS_Purpose? JSON.stringify(this.awsAccountOnboarding.AWS_Purpose): '[]'
      this.awsAccountOnboarding.fields.Customer_Regulations = this.awsAccountOnboarding.Customer_Regulations? JSON.stringify(this.awsAccountOnboarding.Customer_Regulations): "[]";

      if(this.awsAccountOnboarding.fields.SaaS === 'No'){
          this.awsAccountOnboarding.fields.SaaS_Solution = ''
      }
      if(this.awsAccountOnboarding.isPromoCode === 'No'){
        this.awsAccountValidation.awsCredits = ''
      }
      if(this.awsAccountOnboarding.Region === 'false'){
        console.log('custreg')
        this.awsAccountOnboarding.fields.Restricted_Region_Id = ''
      }
      if(this.awsAccountOnboarding.isLocationSpecific){
        this.awsAccountOnboarding.fields.Specific_Location = ''
      }
      if(this.awsAccountOnboarding.requireRegulations === 0){
        this.awsAccountOnboarding.Customer_Regulations = []
      }

      this.awsAccountOnboarding.fields.AWS_Req_Type = this.type
      console.log('THE REQUEST TYPE: ', this.awsAccountOnboarding.fields.AWS_Req_Type )
      this.$emit("continue", this.awsAccountOnboarding.fields);
    },

    addToCustomerRegulations (type) {
      if (type === this.contractRestrictionValue) {
        let contractRestrictionIndex = this.awsAccountOnboarding.Customer_Regulations.findIndex(
          regulation =>
            regulation === 'Contract Restriction' || regulation === type
        )
        if (contractRestrictionIndex >= 0) {
          this.customerRegulations.splice(
            contractRestrictionIndex,
            1,
            this.contractRestrictionText
          )
          this.contractRestrictionValue = this.contractRestrictionText
        }
      }

      if (type === this.otherRestrictionValue) {
        let otherRestrictionIndex = this.awsAccountOnboarding.Customer_Regulations.findIndex(
          regulation =>
            regulation === 'Other Restriction' || regulation === type
        )
        if (otherRestrictionIndex >= 0) {
          this.awsAccountOnboarding.Customer_Regulations.splice(
            otherRestrictionIndex,
            1,
            this.otherRestrictionText
          )
          this.otherRestrictionValue = this.otherRestrictionText
        }
      }
    },

    goBack () {
      console.log('Go back!')
      this.$emit('previous')
    },

    setTrainingAccount() {

      const prodIndex = this.purposes.indexOf('Production(Prod)');
      const devIndex= this.purposes.indexOf('Development (Dev)');
      const toBeExcluded = ['Production(Prod)', 'Development (Dev)']

      this.isTrainingAccount = this.$route.name === 'Request New Training Account'

      if(this.isTrainingAccount) {
        this.$store.commit('user/requestAws/setAwsAccountOnboardingSupportTypeAndIsTraining')

        if (toBeExcluded.includes(this.awsAccountOnboarding.AWS_Purpose.all)) {
          this.$store.commit('user/requestAws/clearAwsAccountOnboardingPurposes')
        }
        // remove production and development from options if account is for training
        if (prodIndex > -1 && devIndex  > -1) {
          this.purposes.splice(prodIndex, 1);
          this.purposes.splice((devIndex-1), 1);
        } 
      } else {
        if ((prodIndex === -1) && (devIndex === -1)) {
          this.purposes.splice(1, 0, 'Production(Prod)');
          this.purposes.splice(4, 0, 'Development (Dev)');
        }
      }
    },

    setIsBulkTraining() {
      if(this.awsAccountOnboarding.fields.Internal_Individual_Training === 'Bulk Training') {
        this.isBulkTraining = true
      } else {
        this.isBulkTraining = false
      }
    },

  }
}
</script>

<style lang="scss" scoped>
section.aws {
  div.acctname {
    background-color: #000;
    padding: 15px 15px;
    margin-bottom: 25px;
    color: #fff;
  }

  .acctname > .desc {
    font-size: 12px;
    font-style: italic;
    margin-bottom: 10px;
  }

  border: 0 dashed #000;
  margin: 15px 0;
  .header {
    background: #000;
    padding: 10px 15px;
    color: #fff;
  }
  .content {
    background-color: #e8e6e6;
    padding: 25px 15px;
    .container {
      padding: 0;
    }
    .button-style-1 {
      padding: 15px 25px;
    }
  }
  .v-btn-toggle .v-btn.v-btn--active{
    background-color: #ff9900 !important;
  }
}
.text50 {
  width: 50%;
}
</style>
